import React from 'react'

export default function hizAsimRaporu() {
    return (
        <div>
            test2
        </div>
    )
}
